// extracted by mini-css-extract-plugin
module.exports = {"addButton":"styles_addButton__1_qGG","container":"styles_container__G4IgL","labels":"styles_labels__3DiTb"};